module.exports = __webpack_public_path__ + "static/media/other.815ebdf9.svg";